import { memo } from 'react';

export const CustomCenter = memo(() => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>切片</title>
    <defs>
      <radialGradient
        cx="9.69206712%"
        cy="0%"
        fx="9.69206712%"
        fy="0%"
        r="155.337971%"
        gradientTransform="translate(0.096921,0.000000),scale(1.000000,0.815747),rotate(62.697461),translate(-0.096921,-0.000000)"
        id="radialGradient-1"
      >
        <stop stopColor="#63A1FF" offset="0%"></stop>
        <stop stopColor="#4A67FE" offset="100%"></stop>
      </radialGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="95.8289513%"
        id="linearGradient-2"
      >
        <stop stopColor="#DBD3FF" offset="0%"></stop>
        <stop stopColor="#BFD5FF" offset="100%"></stop>
      </linearGradient>
      <path
        d="M8.41400853,12.4015713 C6.34521621,14.782751 5.0257811,16.6367609 3,19.7168426 C3.27020372,19.6490836 3.8399823,19.4644953 4.70933574,19.1630774 C6.90621089,16.1916243 8.39783949,14.2269186 9.18422152,13.2689603 L8.41400853,12.4015713 Z"
        id="path-3"
      ></path>
      <filter
        x="0.0%"
        y="0.0%"
        width="100.0%"
        height="100.0%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetInner1"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0.360784314   0 0 0 0 0.380392157   0 0 0 0 1  0 0 0 0.403537137 0"
          type="matrix"
          in="shadowInnerInner1"
        ></feColorMatrix>
      </filter>
      <path
        d="M10.1385033,12.1443 C10.1800447,12.0972899 11.0637561,11.1150632 11.4717622,10.6804652 C11.4717622,10.6804652 11.1046088,9.43955164 11.1046088,9.43955164 C10.5214053,10.0616216 9.99312945,10.6335173 9.50699343,11.1706405 L10.1385033,12.1443 Z"
        id="path-5"
      ></path>
      <filter
        x="0.0%"
        y="0.0%"
        width="100.0%"
        height="100.0%"
        filterUnits="objectBoundingBox"
        id="filter-6"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetInner1"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0.360784314   0 0 0 0 0.380392157   0 0 0 0 1  0 0 0 0.403537137 0"
          type="matrix"
          in="shadowInnerInner1"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="4.4.0" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="V4.4.0" transform="translate(-178.000000, -2110.000000)">
        <g id="编组-15" transform="translate(154.000000, 1868.000000)">
          <g id="导航/左侧导航" transform="translate(12.000000, 16.000000)">
            <g id="左侧导航" transform="translate(0.000000, 60.000000)">
              <g
                id="nav/默认状态备份-2"
                transform="translate(0.000000, 156.000000)"
              >
                <g
                  id="nav/工作台-s"
                  transform="translate(12.000000, 10.000000)"
                >
                  <path
                    d="M16.8964559,1.15611576 L17.5967705,1 L17.2906676,3.23542877 C17.1250139,4.40991662 16.9828645,5.34498897 16.863985,6.04179576 L16.734667,6.75561092 L15,8 C15.9986113,7.94309789 16.4881563,7.95593244 16.468635,8.03850366 C16.4518493,8.1095038 16.4266708,8.21600401 16.3930994,8.35800429 C16.0757843,9.7001855 15.7315903,10.7694382 15.3566277,11.5699006 C13.7120262,15.0807621 11.3205363,16.7227885 6.46918573,16.7227885 L5.96918573,16.7227885 C5.46046101,16.4531021 5.1373991,16.2121726 5,16 C4.8626009,15.7878274 4.78625437,15.4119879 4.77096042,14.8724813 L4.87185198,14.3827662 C5.58044495,10.9433439 7.00139718,8.04650116 9.13428555,5.7018799 C11.2739028,3.34986172 13.8652279,1.83184415 16.8964559,1.15611576 Z"
                    id="路径-12"
                    fill="url(#radialGradient-1)"
                    fillRule="nonzero"
                    opacity="0.746837798"
                  ></path>
                  <g id="路径">
                    <use
                      fill="url(#linearGradient-2)"
                      fillRule="evenodd"
                      xlinkHref="#path-3"
                    ></use>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-4)"
                      xlinkHref="#path-3"
                    ></use>
                  </g>
                  <g id="路径">
                    <use
                      fill="#FFFFFF"
                      fillRule="evenodd"
                      xlinkHref="#path-5"
                    ></use>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-6)"
                      xlinkHref="#path-5"
                    ></use>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
));
